<template>
    <div class="h-screen flex w-full bg-img" id="page-login">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <img src="@/assets/images/logo/zain_logo.png" alt="login"
                                         class="mx-auto self-center zain_logo">
                                    <h4 class="mb-4">Login</h4>
                                    <p>Welcome to <b>Masiya API Manager</b>, please login to your account.</p>
                                </div>
                                <form method="post" @submit.prevent="Login">
                                    <vs-input  val-icon-danger="warning" :danger="errors.has('username')" name="username" v-validate="'required|alpha_dash'" icon="icon icon-user" icon-pack="feather" label-placeholder="Username" v-model="username" class="w-full no-icon-border"/>
                                    <span class="text-danger text-sm" v-show="errors.has('username')">{{ errors.first('username') }}</span>

                                    <vs-input val-icon-danger="warning" :danger="errors.has('password')" type="password" v-validate="'required|min:6'" name="password" icon="icon icon-lock" icon-pack="feather" label-placeholder="Password" v-model="password" class="w-full mt-6 no-icon-border"/>
                                    <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>

                                    <div class="flex flex-wrap justify-between my-5">
                                        <br>
                                    </div>
                                    <vs-button class="float-right">Login
                                        <vs-icon icon="icon-log-in" icon-pack="feather"></vs-icon>
                                    </vs-button>
                                </form>

                                <br><br><br>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>


    import Configs from '../../config.js';

    export default {
        data() {
            return {
                username: '',
                password: '',
                remember_me: false,
                host: null
            }
        },
        mounted:function(){
            let data = JSON.parse(localStorage.getItem('user_data'));
            if (data && data.access_token) {
                this.$router.push({name: "dashboard"});
            }
        },
        created: function () {

            this.host = Configs.host;
        },
        methods: {
            Login() {
                this.$validator.validateAll().then(result => {
                    if (result) {

                        Window.axios({
                            method: 'post',
                            url: this.host + '/api/v1/auth/login',
                            data: this.$data,
                            headers: {
                                "Accept": "application/json",
                                "Content-type": "application/json",
                            }
                        }).then((response) => {
                            localStorage.setItem('user_data', JSON.stringify(response.data));
                            this.$store.commit('SetAppActiveUser', response.data);
                            this.$vs.notify({
                                title: 'Welcome',
                                text: 'You successfully logged in to the system',
                                color: 'success',
                                iconPack: 'feather',
                                icon: 'icon-check'
                            });
                            this.$router.push({name: response.data.redirect_link_name});
                        }).catch((err) => {
                            localStorage.removeItem('user_data');
                            this.$setLaravelValidationErrorsFromResponse(err.response.data);
                        })
                    }
                })
            }
        }
    }
</script>
<style>
    .zain_logo {
        width: 60%;
    }
</style>
<style lang="scss">
    #page-login {
        .social-login {
            .bg-facebook {
                background-color: #1551b1;
            }

            .bg-twitter {
                background-color: #00aaff;
            }

            .bg-google {
                background-color: #1551b1;
            }

            .bg-github {
                background-color: #333;
            }
        }
    }
</style>
